import { render, staticRenderFns } from "./VGantt.vue?vue&type=template&id=a1d8e1d2&"
import script from "./VGantt.vue?vue&type=script&lang=ts&"
export * from "./VGantt.vue?vue&type=script&lang=ts&"
import style0 from "./VGantt.vue?vue&type=style&index=0&id=a1d8e1d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports